export type Size = "xs" | "sm" | "md" | "lg" | "xl" ;

export type VerticalAlignment = "top" | "center" | "bottom" ;

export type HorizontalAlignment = "left" | "center" | "right" ;

export enum TrackType{
    Default = "",
    Dot = "dot"
}

export type Link = {
    title: string;
    url: string;
    target?: string;
    image?: string;
    links?: Link[];
};

export type BannerMediaPosition = "top" | "center" | "bottom" | "left" | "right";